import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons/faChevronCircleDown";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons/faChevronCircleRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListaSistemaTintometrico } from "app/api/classes/ProdutoApi";
import { InputNumerico } from "app/components/inputs/InputNumerico";
import { Separador } from "app/components/separador/Separador";
import clsx from "clsx";
import { useFormik } from "formik";
import globalMU from "globalMU";
import { none } from "ramda";
import React, { useContext, useState } from "react";
import { PaginaPesquisaProdutoContext } from "../pagina-pesquisa-produto/PaginaPesquisaProduto";
const estilosMaisFiltros = require("./MaisFiltros.module.scss").default;


export type MaisFiltrosDados = {
  CodigoFabricante: string;
  SistemaTintometrico: number;
  TextoTecnico: string;
  ModeloProduto: string;
  Disponibilidade: string[];
  ProdutoEmTransito: boolean;
  ProdutoFinal: string;
  ProdutoOferta: boolean;
  ConsiderarEstoqueDisponivelLote: boolean //435588
  TipoFiltroEstoque: string //435588
  QuantidadeInicialFiltroEstoque: number //435588
  QuantidadeFinalFiltroEstoque: number //435588
  ApenasFabricacaoPropria?: boolean //440721
};

export type Disponibilidade = {
  Codigo: number;
  Nome: string;
};

export const MaisFiltros = () => {
  const contexto = useContext(PaginaPesquisaProdutoContext)
  const [mostrarMaisFiltros, setMostrarMaisFiltros] = useState(false);

  const formik = useFormik({
    initialValues: { ...contexto.maisFiltrosDados },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });


  const codigoFabricante = (
    <>
      <label>Código do Fabricante</label>
      <input
        name="CodigoFabricante"
        disabled={contexto.processandoProduto}
        type="text"
        className={estilosMaisFiltros.input}
        maxLength={30}
        value={(formik.values.CodigoFabricante) ?? ""}
        onChange={formik.handleChange}
        onBlur={() =>
          contexto.onCodigoFabricanteModificado(formik.values.CodigoFabricante)
        }
      />
    </>
  );

  const sistemaTintometrico = (
    <>
      <label>Sistema Tintométrico</label>
      <select
        disabled={contexto.processandoProduto}
        className={estilosMaisFiltros.select}
        name="SistemaTintometrico"
        value={formik.values.SistemaTintometrico ?? ""}
        onChange={(e) => {
          formik.handleChange(e);
          contexto.onCodigoSistemaTintometricoModificado(Number(e.target.value));
        }}
      >
        <option value={null}>Selecione</option>
        {contexto.opcoesSistemaTintometrico.map((d) => (
          <option key={d.Codigo} value={d.Codigo}
            disabled={contexto.processandoProduto}>
            {d.Descricao}
          </option>
        ))}
      </select>
    </>
  );

  const textoTecnico = (
    <>
      <label>Texto Técnico</label>
      <input
        className={estilosMaisFiltros.input}
        disabled={contexto.processandoProduto}
        name="TextoTecnico"
        type="text"
        maxLength={30}
        value={(formik.values.TextoTecnico) ?? ""}
        onChange={formik.handleChange}
        onBlur={() =>
          contexto.onTextoTecnicoModificada(formik.values.TextoTecnico)
        }
      />
    </>
  );

  const modelo = (
    <>
      <label>Modelo</label>
      <input
        className={estilosMaisFiltros.input}
        disabled={contexto.processandoProduto}
        name="ModeloProduto"
        type="text"
        maxLength={30}
        value={(formik.values.ModeloProduto) ?? ""}
        onChange={formik.handleChange}
        onBlur={() => contexto.onModeloModificado(formik.values.ModeloProduto)}
      />
    </>
  );

  const disponibilidade = (
    <>
      <label title="Use as teclas SHIFT ou CTRL para selecionar várias disponibilidades">Disponibilidade</label>
      <select
        multiple
        className={clsx(estilosMaisFiltros.input, "_h-auto")}
        title="Use as teclas SHIFT ou CTRL para selecionar várias disponibilidades"
        disabled={contexto.processandoProduto}
        name="Disponibilidade"
        id="MaisFiltros_Disponibilidade"
        value={formik.values.Disponibilidade ?? ""}
        size={9}
        onChange={(e) => {
          const disponibilidadesSelecionadas = Array.from(
            e.target.selectedOptions
          ).map((o) => (o.value));

          formik.setFieldValue("disponibilidade", disponibilidadesSelecionadas);
          contexto.onDisponibilidadesModificadas(disponibilidadesSelecionadas);
        }}

      >
        {contexto.opcoesDisponibilidade.map((d) => (
          <option
            key={d.Codigo}
            value={d.Codigo}
            disabled={contexto.processandoProduto}>
            {d.Nome}
          </option>
        ))}
      </select>
    </>
  );

  const apenasProdutoEmTransito = (
    <>
      <label
        style={{ cursor: "pointer" }}
        htmlFor="MaisFiltros_ProdutoEmTransito"
      >
        Apenas Produto em Trânsito
      </label>
      <input
        className="_mt-1"
        disabled={contexto.processandoProduto}
        type="checkbox"
        id="MaisFiltros_ProdutoEmTransito"
        name="ProdutoEmTransito"
        checked={formik.values.ProdutoEmTransito ?? false}
        onChange={(e) => {
          formik.setFieldValue("ProdutoEmTransito", e.target.checked);
          contexto.onProdutoEmTransitoModificado(e.target.checked);
        }}
      />
    </>
  );

  const apenasProdutoFinal = (
    <>
      <label
        style={{ cursor: "pointer" }}
        htmlFor="MaisFiltros_ProdutoFinal"
      >
        Apenas Produto Final
      </label>
      <input
        className="_mt-1"
        disabled={contexto.processandoProduto}
        type="checkbox"
        name="ProdutoFinal"
        id="MaisFiltros_ProdutoFinal"
        checked={formik.values.ProdutoFinal == "on"}
        onChange={(e) => {
          e.target.checked && formik.setFieldValue("ProdutoFinal", "on");
          contexto.onApenasProdutoFinalModificado(e.target.checked ? "on" : null);
        }}
      />
    </>
  );

  const apenasProdutoOferta = (
    <>
      <label
        style={{ cursor: "pointer" }}
        htmlFor="MaisFiltros_ProdutoOferta"
      >
        Produtos em Oferta
      </label>
      <input
        className="_mt-1"
        disabled={contexto.processandoProduto}
        type="checkbox"
        name="ProdutoOferta"
        id="MaisFiltros_ProdutoOferta"
        checked={formik.values.ProdutoOferta ?? false}
        onChange={(e) => {
          formik.handleChange(e);
          contexto.onProdutoOfertaModificado(e.target.checked);
        }}
      />
    </>
  );

  const fabricacaoPropria =<>
  <label
    style={{ cursor: "pointer" }}
    htmlFor="MaisFiltros_FabricacaoPropria"
  >
    Apenas Fabricação Própria
  </label>
  <input
    className="_mt-1"
    disabled={contexto.processandoProduto}
    type="checkbox"
    name="ApenasFabricacaoPropria"
    id="MaisFiltros_FabricacaoPropria"
    checked={formik.values.ApenasFabricacaoPropria ?? false}
    onChange={(e) => {
      formik.handleChange(e);
      contexto.onApenasFabricacaoPropriaModificado(e.target.checked);
    }}
  />
</>

  const considerarQuantidadeDisponivelLote = contexto.parametroControleLote &&  // 435588
    <>
      <label
        style={{ cursor: "pointer" }}
        title="Considerar estoque do lote &#013;Em vez de considerar a quantidade disponível em estoque, irá considerar o estoque disponível no lote"
        htmlFor="PesquisaProdutos_EstoqueDisponivelLote">
        Estoque Lote</label>
      <input
        type="checkbox"
        id="PesquisaProdutos_EstoqueDisponivelLote"
        title="Considerar estoque do lote &#013;Em vez de considerar a quantidade disponível em estoque, irá considerar o estoque disponível no lote"
        onChange={(e) => {
          formik.handleChange(e);
          contexto.onConsiderarEstoqueDisponivelLote(e.target.checked);
        }}
        checked={formik.values?.ConsiderarEstoqueDisponivelLote ?? false} // 435588
        disabled={!contexto.filtrouAlgumCheckboxEstoquesDisponivel || contexto.processandoProduto}
      />
    </>

  const filtroQuantidadeEstoque =
    <>
      <label>Quantidade Estoque</label>
      <select
        id="MaisFiltros_ComboTipoQuantidadeEstoque"
        className={estilosMaisFiltros.tamanho3}
        disabled={!contexto.filtrouAlgumCheckboxEstoquesDisponivel || contexto.processandoProduto}
        value={formik.values.TipoFiltroEstoque ?? ""}
        onChange={(e) => {
          formik.handleChange(e);

          if (e.target.value == "") //435588
          {
            formik.setFieldValue("QuantidadeFinalFiltroEstoque", null)
            formik.setFieldValue("QuantidadeFinalFiltroEstoque", null)
            contexto.onQuantidadeFinalFiltroEstoqueModificado(null);
            contexto.onQuantidadeFinalFiltroEstoqueModificado(null);
            contexto.maisFiltrosDados.QuantidadeInicialFiltroEstoque = null
            contexto.maisFiltrosDados.QuantidadeFinalFiltroEstoque = null
          }
          if (e.target.value != "Entre") //435588
          {
            formik.setFieldValue("QuantidadeFinalFiltroEstoque", null)
            contexto.onQuantidadeFinalFiltroEstoqueModificado(null);
            contexto.maisFiltrosDados.QuantidadeFinalFiltroEstoque = null
          }

          contexto.onTipoFiltroEstoqueModificado(e.target.value);
        }}
      >
        <option value=""></option>
        <option value="Igual">= (Igual)</option>
        <option value="MaiorQue">&gt; (Maior que)</option>
        <option value="MaiorOuIgual">&gt;= (Maior ou igual)</option>
        <option value="MenorQue">&lt; (Menor que)</option>
        <option value="MenorOuIgual">&lt;= (Menor ou igual)</option>
        <option value="Diferente">&lt;&gt; (Diferente)</option>
        <option value="Entre">&gt;= e &lt;= (Entre)</option>
      </select>

      {formik.values.TipoFiltroEstoque && formik.values.TipoFiltroEstoque != "" && <>
        <label>{formik.values.TipoFiltroEstoque == "Entre" ? "Quantidade Inicial" : "Quantidade"}</label>
        <InputNumerico
          id="MaisFiltros_ValorIncialFiltro"
          disabled={contexto.processandoProduto}
          style={{ width: "100px" }}
          numeroCasasDecimais={3}
          onValorModificado={(valorModificado) => {
            formik.setFieldValue("QuantidadeInicialFiltroEstoque", valorModificado)
            contexto.onQuantidadeInicialFiltroEstoqueModificado(valorModificado)
            if (formik.values.TipoFiltroEstoque == "Entre" && valorModificado > formik.values.QuantidadeFinalFiltroEstoque)
              globalMU.showErrorMessage("Quantidade inicial não pode ser maior que a quantidade inicial");
          }}
          valor={formik.values.QuantidadeInicialFiltroEstoque} />
      </>}

      {formik.values.TipoFiltroEstoque && formik.values.TipoFiltroEstoque == "Entre" && <>
        <label>Quantidade Final</label>
        <InputNumerico
          id="MaisFiltros_ValorFinalFiltro"
          disabled={contexto.processandoProduto}
          style={{ width: "100px" }}
          numeroCasasDecimais={3}
          valor={formik.values.QuantidadeFinalFiltroEstoque}
          onValorModificado={(valorModificado) => {
            formik.setFieldValue("QuantidadeFinalFiltroEstoque", valorModificado)
            contexto.onQuantidadeFinalFiltroEstoqueModificado(valorModificado)
            if (valorModificado < formik.values.QuantidadeInicialFiltroEstoque)
              globalMU.showErrorMessage("Quantidade final não pode ser menor que a quantidade inicial");
          }}
        />
      </>}
    </>

  const legenda = <legend id="MaisFiltros_LegendMaisFiltro">
    <a
      className={estilosMaisFiltros.iconeSub}
      style={{ cursor: "pointer", userSelect: "none" }}
      onClick={(e) => {
        setMostrarMaisFiltros(!mostrarMaisFiltros);
        e.preventDefault();
      }}
    >
      <FontAwesomeIcon
        icon={
          mostrarMaisFiltros
            ? faChevronCircleDown
            : faChevronCircleRight
        }
      />
      Mais Filtros
    </a>
  </legend>

  return (
    <>
      <fieldset className="_my-2"
      disabled={contexto.processandoProduto}>
        <div>
          {legenda}
          {mostrarMaisFiltros && (
            <div>
              <Separador />
              <div
                className={clsx(
                  estilosMaisFiltros.customGrid,
                  "_grid _grid-cols-2 _gap-y-1.5 _gap-x-2 _float-left"
                )}
              >
                {codigoFabricante}

                {contexto.utilizaSistemaTintometrico && sistemaTintometrico}

                {textoTecnico}

                {modelo}

                {disponibilidade}

                {contexto.produtoEmTransito && apenasProdutoEmTransito}

                {apenasProdutoFinal}

                {apenasProdutoOferta}

                {considerarQuantidadeDisponivelLote}
                {filtroQuantidadeEstoque}
                {fabricacaoPropria}

              </div>
            </div>
          )}
        </div>
      </fieldset>
    </>
  );
};
